









// vendor
import { defineComponent, computed, ref, PropType, inject } from "@vue/composition-api";
// project
import { Session } from "@/psychlab/types/sessions";
import { SessionContext } from "../ts/SessionContext";

export default defineComponent({
	setup(props){

		const getSessionContext = inject<() => SessionContext>("getSessionContext");

		if(!getSessionContext){
			throw Error("Session Progress Bar: Session context missing!")
		}

		const {
			progressStepIndex,
			progressStepCount,
		} = getSessionContext();

		const steps = computed(() => {
			const steps:any = [];
			for(let i = 0; i < progressStepCount.value; i++){
				steps.push(i <= progressStepIndex.value);
			}
			return steps;
		});

		return {
			steps,
		};
	}
});

